import { EOrderStatus } from "../enums/EOrderStatus";

export const getStatusColor = (status: EOrderStatus) => {
  if (status === EOrderStatus.DELIVERED) return "success";
  if (status === EOrderStatus.CANCELED) return "danger";
  return "warning";
};
